var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import { VIRTUAL_PROPS_ACCESSOR, VirtualPropertiesModel } from '@core/shared/virtual-properties';
import { UseRestraints } from '@core/shared/restraints';
import { truncateText } from '@core/shared/utils';
import { CrudEndpoints, EditorDefinition, Expose, IdItemModel, ItemModelDefinition, ItemModelProp, MinLength, Trim, Structure, ValidateNested, ModelId } from '@core/shared/model';
import { CompanyRestraints } from './company.restraints';
import { UserItem } from './user.item';
import { CompanyVirtualPropertyBaseDefinition } from './company-virtual-props-base-definition';
import { SKILLSETS_ACCESSOR, SKILLSET_IDS_ACCESSOR, WithSkillsets } from '@common/abilities/shared';
import { ReferrerItem } from './referrer.item';
import { CompanyClientStatus } from '../enum/company-client-status.enum';
import { CompanyDemoItem } from './company-demo.item';
import { CompanyAddressItem } from './company-address.item';
let CompanyItem = /*#__PURE__*/(() => {
  let CompanyItem = class CompanyItem extends IdItemModel {
    static {
      _a = VIRTUAL_PROPS_ACCESSOR, _b = SKILLSETS_ACCESSOR, _c = SKILLSET_IDS_ACCESSOR;
    }
    toString() {
      return "Company " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], CompanyItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], CompanyItem.prototype, "updateDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], CompanyItem.prototype, "enabled", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: CompanyClientStatus.New
  }), __metadata("design:type", String)], CompanyItem.prototype, "clientStatus", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], CompanyItem.prototype, "demoId", void 0);
  __decorate([Expose(), __metadata("design:type", CompanyDemoItem)], CompanyItem.prototype, "demo", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), MinLength(3), Trim(), __metadata("design:type", String)], CompanyItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: []
  }), __metadata("design:type", Array)], CompanyItem.prototype, "optInFeatures", void 0);
  __decorate([Expose(), Structure(Array, () => UserItem), __metadata("design:type", Array)], CompanyItem.prototype, "users", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], CompanyItem.prototype, "usersCount", void 0);
  __decorate([Expose(), Structure(Array, () => UserItem), __metadata("design:type", Array)], CompanyItem.prototype, "managers", void 0);
  __decorate([Expose(), Structure(Array, () => CompanyAddressItem), __metadata("design:type", Array)], CompanyItem.prototype, "addresses", void 0);
  __decorate([Expose(), ValidateNested(), __metadata("design:type", Object)], CompanyItem.prototype, _a, void 0);
  __decorate([Expose(), __metadata("design:type", Number)], CompanyItem.prototype, "referrerId", void 0);
  __decorate([Expose(), __metadata("design:type", ReferrerItem)], CompanyItem.prototype, "referrer", void 0);
  __decorate([Expose(), __metadata("design:type", String)], CompanyItem.prototype, "referrerCode", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], CompanyItem.prototype, "notes", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], CompanyItem.prototype, "privateNotes", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], CompanyItem.prototype, "customerId", void 0);
  __decorate([Expose(), __metadata("design:type", Array)], CompanyItem.prototype, _b, void 0);
  __decorate([Expose(), __metadata("design:type", Array)], CompanyItem.prototype, _c, void 0);
  CompanyItem = __decorate([EditorDefinition('admin-new', {
    enabled: true,
    clientStatus: true,
    name: true
  }, {
    useCrudEndpoint: 'admin'
  }), EditorDefinition('admin-general', {
    enabled: true,
    clientStatus: true,
    demoId: 'readonly',
    name: true,
    [VIRTUAL_PROPS_ACCESSOR]: {
      loadDefinition: 'default'
    },
    [SKILLSET_IDS_ACCESSOR]: true,
    notes: true,
    privateNotes: true,
    referrerId: true,
    customerId: true
  }, {
    useCrudEndpoint: 'admin'
  }), EditorDefinition('admin-features', {
    optInFeatures: true
  }, {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/users/companies'
  }, {
    clientCache: {
      seconds: 15 * 60,
      clearOnUserChange: true,
      endpoints: {
        admin: true
      }
    }
  }), UseRestraints(CompanyRestraints), ItemModelDefinition({
    texts: {
      newItem: 'Neues Unternehmen erstellen',
      editItem: item => `Unternehmensverwaltung "${truncateText(item.name, 40)}"`,
      item: 'Unternehmen',
      items: 'Unternehmen'
    }
  }), VirtualPropertiesModel({
    definition: CompanyVirtualPropertyBaseDefinition
  }), WithSkillsets(), ModelId("CompanyItem") // auto-generated by generate-model-ids
  ], CompanyItem);
  return CompanyItem;
})();
export { CompanyItem };